import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { groupBy, uniqueId } from 'lodash'
import { ScansList } from '@src/screens/Scans/components/ScansList'
import { DATE_FORMAT, MONTH_NAME_AND_DATE_WITH_YEAR_FORMAT } from '@src/config/momentFormat'
import { NavigationContainer } from '@src/screens/Common/containers'
import { scansMeasurementsSelector } from '@src/selectors/scans'
import { calendarDateSelector } from '@src/selectors/app'

const FILTER = { scope: 'graph' }
const PAGINATION = { type: 'date' }
const SORT = {
  orderBy: 'occurred_at',
  order: 'descending',
}

export const ScansContainer = () => {
  const measurements = useSelector(scansMeasurementsSelector)
  const calendar = useSelector(calendarDateSelector)

  const items = useMemo(() => {
    const items = measurements.sort(
      (a, b) => moment(b.occurredAt).unix() - moment(a.occurredAt).unix(),
    )

    const dateGroups = groupBy(items, (i) => moment(i.occurredAt).format(DATE_FORMAT))
    return Object.keys(dateGroups).map((date) => ({
      id: uniqueId(date),
      title: moment(date).format(MONTH_NAME_AND_DATE_WITH_YEAR_FORMAT),
      occurredAt: moment(date),
      data: dateGroups[date],
    }))
  }, [measurements])

  return (
    <NavigationContainer title="Sensor Data">
      <ScansList
        items={items}
        name="scans"
        dataPath="measurements"
        filter={FILTER}
        sort={SORT}
        pagination={PAGINATION}
        calendar={calendar}
        useCache={false}
      />
    </NavigationContainer>
  )
}
